import axios from "axios";
import {route} from "ziggy-js";

export const acceptCookie = async (): Promise<void> => {
    try {
        await axios.post(route("cookie.add"));
    } catch {
        // Не блокируем пользователя: при следующей загрузке баннер просто покажется снова
    }
};
